// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Uz-z","tooltipWrapper":"Vz-z","icon":"Wz-z","tooltip":"Xz-z","content":"Yz-z"};